app.controller('DataApiPostController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    const siteHelper = $rootScope.site_helper;

    const dataApiID = $scope.data_api_id ? $scope.data_api_id : ($state.$current && $state.$current.data ? $state.$current.data.data_api_id : null);
    const postSlug = $scope.post_slug ? $scope.post_slug : $stateParams.post_slug;

    const relatedMax = 10;

    const dataApiService = $rootScope.service.data_api;

    const data_api_model = dataApiService.factory.getModel({data_api_id: dataApiID});

    $scope.post = null;
    $scope.related_post_list = [];

    function getRelatedPostList() {
        let categorySlug;

        if (!$scope.post) {
            return;
        }
        const categoryLayers = [];

        const requiredRootDataApiIDs = {};

        function checkComplete() {
            if (siteHelper.keyCount(requiredRootDataApiIDs) > 0) {
                return;
            }
            const allSlugs = {};
            const relatedPostList = [];
            allSlugs[$scope.post.slug] = true;
            for (let i = 0; i < categoryLayers.length; i++) {
                const categoryLayer = categoryLayers[i];
                let index = -1;
                while (true) {
                    index++;
                    let haveAny = false;
                    for (let j = 0; j < categoryLayer.categories.length; j++) {
                        const modelCategory = data_api_model.categories[categoryLayer.categories[j].slug];
                        if (index < modelCategory.post_list.length) {
                            haveAny = true;
                            const post = modelCategory.post_list[index];
                            if (allSlugs[post.slug]) {
                                continue;
                            }
                            allSlugs[post.slug] = true;
                            relatedPostList.push(post);
                            if (relatedPostList.length === relatedMax) {
                                break;
                            }
                        }
                    }

                    if (!haveAny || relatedPostList.length === relatedMax) {
                        break;
                    }
                }
                if (relatedPostList.length === relatedMax) {
                    break;
                }
            }
            $scope.related_post_list = relatedPostList;
        }

        function requireCategory(categorySlug) {
            data_api_model.requireCategoryPostList(categorySlug, function () {
                delete requiredRootDataApiIDs[categorySlug];
                checkComplete();
            });
        }

        for (categorySlug in $scope.post.categories) {
            const category = $scope.post.categories[categorySlug];
            if (!category.parentSlug || !$scope.post.categories[category.parentSlug]) {
                requiredRootDataApiIDs[categorySlug] = true;
            }
            let categoryLayer = null;
            for (let i = 0; i < categoryLayers.length; i++) {
                if (categoryLayers[i].childDepth === category.childDepth) {
                    categoryLayer = categoryLayers[i];
                }
            }
            if (!categoryLayer) {
                categoryLayer = {childDepth: category.childDepth, categories: []};
                categoryLayers.push(categoryLayer);
            }
            categoryLayer.categories.push(category);
        }
        categoryLayers.sort(function (a, b) {
            if (a.childDepth < b.childDepth) {
                return -1;
            }
            if (a.childDepth > b.childDepth) {
                return 1;
            }
        })

        checkComplete();

        for (categorySlug in requiredRootDataApiIDs) {
            requireCategory(categorySlug);
        }
    }

    if (postSlug) {
        data_api_model.requirePost(postSlug, function (post) {
            $scope.post = post;
            getRelatedPostList();
        });
    }

}])

